(() => {
  const SECTION_SUFFIX = '__product_list_Ert8Dk';
  const INTERVAL_MS = 5500;

  function setup(section) {
    if (!section || section.dataset.agAutoplayReady === 'true') return;
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const carousel = section.querySelector('slideshow-component[ref="resourceListCarousel"]');
    const scroller = carousel?.querySelector('slideshow-slides[ref="scroller"]');
    const next = carousel?.querySelector('button[aria-label="Next slide"]');
    if (!carousel || !scroller || !next) return;

    section.dataset.agAutoplayReady = 'true';
    let timer;

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    const advance = () => {
      if (document.hidden) return;
      if (next.disabled) {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        next.click();
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(advance, INTERVAL_MS);
    };

    section.addEventListener('pointerenter', stop);
    section.addEventListener('pointerleave', start);
    section.addEventListener('focusin', stop);
    section.addEventListener('focusout', start);
    section.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    start();
  }

  function init(root = document) {
    const selector = `[id$="${SECTION_SUFFIX}"]`;
    if (root.matches?.(selector)) setup(root);
    root.querySelectorAll?.(selector).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
